import React, { useEffect, useRef, useState } from 'react';
import { Download, Award, Lock } from 'lucide-react';

const W = 1200;
const H = 850;

export const CertificateCard = ({ courseTitle, userName, userEmail, area, modulo, score, issuedAt, enabled = false }) => {
  const canvasRef = useRef(null);
  const [dataUrl, setDataUrl] = useState(null);

  useEffect(() => {
    if (!enabled) return;
    const cv = canvasRef.current;
    if (!cv) return;
    const ctx = cv.getContext('2d');
    if (!ctx) return;

    // Fondo
    ctx.fillStyle = '#0a1a2a';
    ctx.fillRect(0, 0, W, H);

    // Borde dorado
    ctx.strokeStyle = '#c5a059';
    ctx.lineWidth = 10;
    ctx.strokeRect(25, 25, W - 50, H - 50);
    ctx.lineWidth = 2;
    ctx.strokeRect(40, 40, W - 80, H - 80);

    // Marca de agua
    ctx.save();
    ctx.globalAlpha = 0.06;
    ctx.fillStyle = '#c5a059';
    ctx.font = 'bold 320px "Times New Roman", serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('⚓', W / 2, H / 2);
    ctx.restore();

    // Encabezado
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    ctx.fillStyle = '#c5a059';
    ctx.font = 'bold 22px "Courier New", monospace';
    ctx.fillText('PLATAFORMA VORTEX · ACADEMIA', W / 2, 140);

    ctx.fillStyle = '#ffffff';
    ctx.font = 'bold 64px "Times New Roman", serif';
    ctx.fillText('Certificado de Aprobación', W / 2, 235);

    ctx.fillStyle = '#9db4c8';
    ctx.font = '20px "Times New Roman", serif';
    ctx.fillText('Otorgado a', W / 2, 320);

    ctx.fillStyle = '#c5a059';
    ctx.font = 'bold 44px "Times New Roman", serif';
    ctx.fillText((userName || 'Estudiante').toUpperCase(), W / 2, 395);

    // Correo del usuario
    ctx.fillStyle = '#9db4c8';
    ctx.font = '18px "Courier New", monospace';
    ctx.fillText(userEmail || '', W / 2, 440);

    ctx.fillStyle = '#ffffff';
    ctx.font = 'italic 24px "Times New Roman", serif';
    ctx.fillText('por haber aprobado satisfactoriamente el módulo', W / 2, 505);

    ctx.fillStyle = '#c5a059';
    ctx.font = 'bold 32px "Times New Roman", serif';
    ctx.fillText(modulo || courseTitle || 'Módulo Vortex', W / 2, 560);

    if (area) {
      ctx.fillStyle = '#9db4c8';
      ctx.font = '20px "Times New Roman", serif';
      ctx.fillText(`Área: ${area}`, W / 2, 610);
    }

    if (score != null) {
      ctx.fillStyle = '#9db4c8';
      ctx.font = '18px "Courier New", monospace';
      ctx.fillText(`Calificación final: ${score}% · Umbral mínimo: 70%`, W / 2, 650);
    }

    // Fecha de aprobación (sin firma)
    const date = issuedAt ? new Date(issuedAt) : new Date();
    const dateStr = date.toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
    ctx.fillStyle = '#9db4c8';
    ctx.font = '18px "Times New Roman", serif';
    ctx.fillText(`Aprobado el ${dateStr}`, W / 2, 700);

    setDataUrl(cv.toDataURL('image/png'));
  }, [enabled, courseTitle, userName, userEmail, area, modulo, score, issuedAt]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      {enabled && dataUrl && (
        <img src={dataUrl} alt="Certificado" style={{ width: '100%', height: 'auto', borderRadius: '10px', border: '1px solid rgba(197,160,89,0.3)' }} />
      )}
      {enabled && !dataUrl && (
        <canvas ref={canvasRef} width={W} height={H} style={{ width: '100%', height: 'auto', borderRadius: '10px', border: '1px solid rgba(197,160,89,0.3)' }} />
      )}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap' }}>
        <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: '6px' }}>
          {enabled ? (
            <Award className="w-4 h-4" style={{ color: '#c5a059' }} />
          ) : (
            <Lock className="w-4 h-4" style={{ color: 'var(--text-muted)' }} />
          )}
          {enabled
            ? 'Certificado listo para descargar en PNG.'
            : 'Aprueba el examen final de este tema con al menos 70% para desbloquear su certificado.'}
        </span>
        <a
          href={enabled ? dataUrl : '#'}
          download={`certificado_${(modulo || courseTitle || 'modulo').toLowerCase().replace(/\s+/g, '_')}.png`}
          onClick={(e) => { if (!enabled || !dataUrl) e.preventDefault(); }}
          style={{
            display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 20px', borderRadius: '10px',
            fontSize: '0.8rem', fontWeight: 'bold', cursor: enabled ? 'pointer' : 'not-allowed',
            border: 'none',
            background: enabled ? 'linear-gradient(135deg, #c5a059, #8f6f2f)' : 'rgba(197,160,89,0.15)',
            color: enabled ? '#0a1a2a' : 'var(--text-muted)', textDecoration: 'none',
          }}
        >
          <Download className="w-4 h-4" />
          <span>{enabled ? 'Descargar Certificado PNG' : 'Certificado Bloqueado'}</span>
        </a>
      </div>
    </div>
  );
};
